module.exports = require("@splunk/dashboard-visualizations/Text");